var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length
    ? _c("recycle-scroller", {
        ref: "scroller",
        staticClass: "recycle-scroller-ks scroller",
        attrs: {
          items: _vm.items,
          "item-size": _vm.itemSize,
          buffer: _vm.buffer,
          keyField: _vm.prop.value,
          "page-mode": _vm.pageMode,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ item, active, index }) {
                return [
                  _vm.type === "select"
                    ? _c(
                        "div",
                        {
                          staticClass: "select-ppt__item",
                          class: {
                            selected:
                              `${_vm.selectValue}` ===
                              `${item[_vm.prop.value]}`,
                          },
                          style: { display: active ? "flex" : "none" },
                          on: {
                            click: function ($event) {
                              return _vm.changeSelectOptions(item)
                            },
                          },
                        },
                        [
                          _vm._t("default", null, {
                            item: item,
                            active: active,
                            prop: _vm.prop,
                            index: index,
                          }),
                        ],
                        2
                      )
                    : _c(
                        "div",
                        [
                          _vm._t("default", null, {
                            item: item,
                            active: active,
                            prop: _vm.prop,
                            index: index,
                          }),
                        ],
                        2
                      ),
                ]
              },
            },
          ],
          null,
          true
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }